import { Component } from '@angular/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { PointingSystemTabs } from '../../models/pointing-system.enums'
import { PointingListModel } from '../../models/pointing-system.models'
import { ActivatedRoute, Router } from '@angular/router'
import { PointingSystemService } from '../../services/pointing-system.service'
import { Subscription } from 'rxjs'

@Component({
	selector: 'app-points-history-list',
	templateUrl: './points-history-list.component.html',
	styleUrl: './points-history-list.component.scss',
})
export class PointsHistoryListComponent {
	subscription = new Subscription()
	tabs = this.SharedService.returnEnumArray(PointingSystemTabs)
	pointsFilter = {
		countryId: 224,
		activeTab: 1,
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		startDate: '',
		endDate: '',
		pointingCheckpoint: '',
	}
	pointsHistoryList: PointingListModel[] = []
	totalCount = this.pointsHistoryList.length
	filterCount = 0
	constructor(
		private SharedService: SharedService,
		private router: Router,
		private ActivatedRoute: ActivatedRoute,
		private PointingSystemService: PointingSystemService
	) {}
	ngOnInit() {
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.pointsFilter.countryId = res['country'] || 224
				this.pointsFilter.activeTab = Number(res['activeTab']) || 1
				this.pointsFilter.paging.pageNumber = res['page'] || 1
				this.pointsFilter.paging.pageSize = res['count'] || 10
				this.SharedService.handleBreadCrumb('Pointing-System-List', true, {
					name: '',
					id: '',
					url: '/layout/pointing-system/points-history',
					queryParams: { ...res },
				})
				this.getHistoryPointsList()
				this.SharedService.headerTitle.next(`SIDEBAR.POINTS_HISTORY`)
			})
		)
	}

	getHistoryPointsList() {
		this.PointingSystemService.pointsHistoryList(this.pointsFilter).subscribe(
			(res: any) => {
				this.pointsHistoryList = res.result.items
				this.totalCount = res.result.totalCount
			}
		)
	}
	pagingChanged(pageNumber: number, pageCount: number) {
		this.router.navigate(['/layout/pointing-system/points-history'], {
			queryParams: {
				page: pageNumber,
				count: pageCount,
			},
			queryParamsHandling: 'merge',
		})
	}
	urlParamsChange(event: number, paramName: string) {
		this.router.navigate(['/layout/pointing-system/points-history'], {
			queryParams: {
				[paramName]: event,
			},
			queryParamsHandling: 'merge',
		})
	}
}
